/**
 * Normalise platform credits mode from Firestore (same rules as Cloud Functions `creditPacks.ts`).
 */
export type CreditsSystemMode = 'enabled' | 'disabled' | 'admin_only';

export function normalizeCreditsSystemModeValue(raw: unknown): CreditsSystemMode {
  if (raw == null || raw === '') return 'enabled';
  const t = String(raw)
    .trim()
    .toLowerCase()
    .replace(/-/g, '_')
    .replace(/\s+/g, '_');
  if (t === 'disabled') return 'disabled';
  if (t === 'enabled') return 'enabled';
  if (t === 'admin_only' || t === 'adminonly') return 'admin_only';
  return 'enabled';
}

/** Read mode from full `systemSettings/platform` document (top-level or `settings` map). */
export function normalizeCreditsSystemModeFromPlatformData(
  data: Record<string, unknown> | undefined,
): CreditsSystemMode {
  const raw =
    data?.creditsSystemMode ??
    (typeof data?.settings === 'object' && data?.settings !== null && !Array.isArray(data.settings)
      ? (data.settings as Record<string, unknown>).creditsSystemMode
      : undefined);
  return normalizeCreditsSystemModeValue(raw);
}
